(function () {

  // ========== CONFIGURATION ==========
  const INSURANCE_HANDLE = 'insurance-product';
  const MANUAL_REMOVE_FLAG = 'autoInsuranceRemoved';

  // ========== STATE ==========
  let isProcessing = false;
  let isCheckboxProcessing = false;
  let insuranceProduct = null;

  // ========== CONTEXT DETECTION ==========
  function isCartPage() {
    return !!document.getElementById('main-cart-footer');
  }

  function isCartDrawer() {
    return !!document.querySelector('cart-drawer');
  }

  // ========== UTIL ==========
  async function fetchJSON(url) {
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
    return res.json();
  }

  async function getCart() {
    return fetchJSON('/cart.js');
  }

  async function getInsuranceProduct() {
    if (insuranceProduct) return insuranceProduct;
    insuranceProduct = await fetchJSON(`/products/${INSURANCE_HANDLE}.js`);
    return insuranceProduct;
  }

  function updateCheckboxState(checked, skipEvent = false) {
    // Update ALL checkboxes on the page (drawer + cart page)
    document.querySelectorAll('#insurance-checkbox').forEach(cb => {
      cb.checked = checked;
      if (!skipEvent) {
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // ========== MODAL ==========
  function showRemovalModal() {
    return new Promise(resolve => {
      document.body.style.overflow = 'hidden';

      const html = `
      <div id="insurance-removal-modal" style="
        position:fixed; inset:0; background:rgba(0,0,0,.5);
        display:flex; align-items:center; justify-content:center; z-index:9999;">
        <div style="background:#fff; padding:25px; max-width:80%; border-radius:8px;
          text-align:center;">
          <p>
            By choosing to disable Shipping Insurance, you acknowledge that Scent Snip is not
            responsible for any loss, damage, or theft that may occur during transit. In the
            event of such incidents, claims must be filed directly with the shipping carrier.
            <br><br>
            If Shipping Insurance is enabled, Scent Snip will assist with claims and ensure
            full coverage under our protection policy.
          </p>
          <button id="ins-yes" style="padding:10px 15px; color:white; background:#25394c;
            border:0; border-radius:5px; margin:5px;">Remove Insurance</button>
          <button id="ins-no" style="padding:10px 15px; color:white; background:#25394c;
            border:0; border-radius:5px; margin:5px;">Keep Insurance</button>
        </div>
      </div>`;

      document.body.insertAdjacentHTML('beforeend', html);
      const modal = document.getElementById('insurance-removal-modal');

      modal.querySelector('#ins-yes').onclick = () => {
        modal.remove();
        document.body.style.overflow = '';
        resolve(true);
      };
      modal.querySelector('#ins-no').onclick = () => {
        modal.remove();
        document.body.style.overflow = '';
        resolve(false);
      };
    });
  }

  // ========== INSURANCE VARIANT ==========
  function getCorrectVariant(product, subtotal) {
    let title = '';
    if (subtotal <= 250) title = 'Below $250';
    else if (subtotal <= 550) title = 'Below $550';
    else title = 'Above $550';

    return product.variants.find(v => v.title === title) || product.variants[0];
  }

  // ========== CART MODIFICATION (with sections) ==========
  async function modifyCartWithSections(action, data) {
    const sectionsToFetch = ['cart-drawer', 'cart-icon-bubble', 'main-cart-footer', 'main-cart-items'];

    const payload = { ...data, sections: sectionsToFetch };

    const res = await fetch(`/cart/${action}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error(`Cart ${action} failed: ${res.status}`);
    return res.json();
  }

  // ========== APPLY UPDATES TO CART DRAWER ==========
  function applyDrawerUpdates(sections) {
    const drawerHtml = sections['cart-drawer'];
    if (!drawerHtml) return;

    const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');

    const drawerItemsTarget = document.querySelector('cart-drawer-items');
    const drawerItemsSource = parsed.querySelector('cart-drawer-items');
    if (drawerItemsTarget && drawerItemsSource) {
      drawerItemsTarget.replaceWith(drawerItemsSource);
    }

    const footerTarget = document.querySelector('.cart-drawer__footer');
    const footerSource = parsed.querySelector('.cart-drawer__footer');
    if (footerTarget && footerSource) {
      footerTarget.replaceWith(footerSource);
    }
  }

  // ========== APPLY UPDATES TO CART PAGE ==========
  function applyCartPageUpdates(sections) {
    // Update the cart items list
    const cartItemsHtml = sections['main-cart-items'];
    if (cartItemsHtml) {
      const parsed = new DOMParser().parseFromString(cartItemsHtml, 'text/html');
      const target = document.querySelector('#main-cart-items .js-contents');
      const source = parsed.querySelector('#main-cart-items .js-contents');
      if (target && source) {
        target.replaceWith(source);
      }
    }

    // Update the cart footer subtotal/totals
    const footerHtml = sections['main-cart-footer'];
    if (footerHtml) {
      const parsed = new DOMParser().parseFromString(footerHtml, 'text/html');

      // Only update the js-contents inside the footer (subtotal block)
      // This avoids wiping the insurance checkbox which is outside .js-contents
      const footerTarget = document.querySelector('#main-cart-footer .js-contents');
      const footerSource = parsed.querySelector('#main-cart-footer .js-contents');
      if (footerTarget && footerSource) {
        footerTarget.replaceWith(footerSource);
      }
    }
  }

  // ========== APPLY UPDATES TO CART ICON BUBBLE ==========
  function applyBubbleUpdate(sections) {
    const bubbleHtml = sections['cart-icon-bubble'];
    if (!bubbleHtml) return;

    const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
    const source = parsed.querySelector('.shopify-section');
    const target = document.getElementById('cart-icon-bubble');
    if (target && source) {
      target.innerHTML = source.innerHTML;
    }
  }

  // ========== MASTER APPLY UPDATES ==========
  function applySectionUpdates(cartResponse) {
    const sections = cartResponse.sections || {};

    if (isCartDrawer()) {
      applyDrawerUpdates(sections);
    }

    if (isCartPage()) {
      applyCartPageUpdates(sections);
    }

    applyBubbleUpdate(sections);

    // Re-bind checkbox listeners after DOM replacement
    bindCheckbox();
  }

  // ========== MAIN INSURANCE LOGIC ==========
  async function manageInsurance() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const [cart, product] = await Promise.all([
        getCart(),
        getInsuranceProduct()
      ]);

      const subtotal = cart.items_subtotal_price / 100;
      const correctVariant = getCorrectVariant(product, subtotal);

      const insuranceItem = cart.items.find(i => i.handle === INSURANCE_HANDLE);
      const hasOtherItems = cart.items.some(i => i.handle !== INSURANCE_HANDLE);
      const manuallyRemoved = sessionStorage.getItem(MANUAL_REMOVE_FLAG) === 'true';

      // Sync checkbox state with actual cart state
      updateCheckboxState(!!insuranceItem, true);

      // AUTO ADD: cart has real items, no insurance, user hasn't manually removed
      if (hasOtherItems && !insuranceItem && !manuallyRemoved) {
        const cartResponse = await modifyCartWithSections('add', {
          id: correctVariant.id,
          quantity: 1
        });
        applySectionUpdates(cartResponse);
        updateCheckboxState(true, true);
        return;
      }

      // AUTO REMOVE: only insurance left, no real items
      if (!hasOtherItems && insuranceItem) {
        const cartResponse = await modifyCartWithSections('change', {
          id: insuranceItem.key,
          quantity: 0
        });
        applySectionUpdates(cartResponse);
        updateCheckboxState(false, true);
        return;
      }

      // UPDATE TIER: insurance exists but wrong variant for current subtotal
      if (insuranceItem && insuranceItem.variant_id !== correctVariant.id) {
        await modifyCartWithSections('change', {
          id: insuranceItem.key,
          quantity: 0
        });
        const cartResponse = await modifyCartWithSections('add', {
          id: correctVariant.id,
          quantity: 1
        });
        applySectionUpdates(cartResponse);
        return;
      }

    } catch (err) {
      console.error('[Insurance] manageInsurance error:', err);
    } finally {
      isProcessing = false;
    }
  }

  // ========== CHECKBOX HANDLER ==========
  async function handleCheckboxChange(e) {
    // Prevent the event from being handled by multiple checkboxes
    if (isCheckboxProcessing) return;
    isCheckboxProcessing = true;

    const checked = e.target.checked;

    try {
      const cart = await getCart();
      const insuranceItem = cart.items.find(i => i.handle === INSURANCE_HANDLE);

      if (checked) {
        // User wants to re-add insurance
        sessionStorage.removeItem(MANUAL_REMOVE_FLAG);
        if (!insuranceItem) {
          await manageInsurance();
        }
      } else {
        // User wants to remove — show confirmation
        const ok = await showRemovalModal();

        if (!ok) {
          // User kept insurance, restore checkbox
          updateCheckboxState(true, true);
          return;
        }

        if (insuranceItem) {
          sessionStorage.setItem(MANUAL_REMOVE_FLAG, 'true');
          const cartResponse = await modifyCartWithSections('change', {
            id: insuranceItem.key,
            quantity: 0
          });
          applySectionUpdates(cartResponse);
          updateCheckboxState(false, true);
        }
      }

    } catch (err) {
      console.error('[Insurance] handleCheckboxChange error:', err);
      // Revert checkbox on error
      const cart = await getCart().catch(() => null);
      if (cart) {
        const has = cart.items.some(i => i.handle === INSURANCE_HANDLE);
        updateCheckboxState(has, true);
      }
    } finally {
      isCheckboxProcessing = false;
    }
  }

  // ========== BIND CHECKBOX ==========
  // Uses event delegation on document so it survives DOM replacement
  let checkboxDelegationBound = false;

  function bindCheckbox() {
    // Direct bind for any currently existing checkboxes
    document.querySelectorAll('#insurance-checkbox').forEach(cb => {
      cb.removeEventListener('change', handleCheckboxChange);
      cb.addEventListener('change', handleCheckboxChange);
    });

    // Event delegation as fallback — only bind once
    if (!checkboxDelegationBound) {
      checkboxDelegationBound = true;
      document.addEventListener('change', (e) => {
        if (e.target && e.target.id === 'insurance-checkbox') {
          handleCheckboxChange(e);
        }
      });
    }
  }

  // ========== LISTEN FOR EXTERNAL CART UPDATES ==========
  function listenForCartEvents() {
    // Intercept all fetch calls to cart mutation endpoints
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);

      const url = typeof args[0] === 'string'
        ? args[0]
        : (args[0]?.url || '');

      const isCartMutation =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update');

      // Only react to non-insurance mutations to avoid infinite loops
      const bodyStr = args[1]?.body || '';
      const isInsuranceMutation = bodyStr.includes
        ? bodyStr.includes(INSURANCE_HANDLE)
        : false;

      if (isCartMutation && !isInsuranceMutation) {
        response.clone().json().then(() => {
          setTimeout(manageInsurance, 600);
        }).catch(() => {});
      }

      return response;
    };
  }

  // ========== INIT ==========
  function init() {
    bindCheckbox();
    listenForCartEvents();
    manageInsurance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
